<template>
  <b-modal
    :active.sync="opened"
    width="700px"
    scroll="keep"
    @close="refreshState()"
  >
    <div class="card">
      <div class="card-content tw-p-6">
        <div class="section-block tw-mb-5">
          <div class="title">{{ labels.title }}</div>
        </div>
        <form>
          <validation-observer v-slot="{ valid }" ref="createEv">
            <div class="columns event-add">
              <div class="column is-half tw-m-0">
                <validation-provider
                  name="title"
                  rules="required|min:5"
                  v-slot="{ errors }"
                >
                  <b-field
                    label="Title"
                    :message="errors"
                    :type="{ 'is-danger': errors.length }"
                  >
                    <b-input v-model="formEvent.values.name"></b-input>
                  </b-field>
                </validation-provider>

                <validation-provider name="description">
                  <b-field label="Description">
                    <b-input
                      type="textarea"
                      v-model="formEvent.values.description"
                      maxlength="500"
                    ></b-input>
                  </b-field>
                </validation-provider>
              </div>
              <div class="column is-half">
                <div class="columns tw-my-2 is-vcentered">
                  <div class="column is-half">
                    <validation-provider>
                      <b-field class="tw-mb-0">
                        <b-checkbox v-model="formEvent.values.is_recurring"
                          ><small><strong>Recurring</strong></small></b-checkbox
                        >
                      </b-field>
                    </validation-provider>
                  </div>
                  <div class="column is-half">
                    <b-field class="tw-mb-0">
                      <b-checkbox v-model="formEvent.values.is_all_day"
                        ><small><strong>All day</strong></small></b-checkbox
                      >
                    </b-field>
                  </div>
                </div>
                <div class="columns is-12">
                  <div class="column">
                    <div
                      class="tw-mb-12 repeat-by"
                      v-if="formEvent.values.is_recurring"
                    >
                      <validation-provider
                        name="repeat_by"
                        rules="required"
                        v-slot="{ errors }"
                        vid="repeatby"
                      >
                        <b-field
                          label="Repeat by"
                          :message="errors"
                          :type="{ 'is-danger': errors.length }"
                          grouped
                          group-multiline
                          expanded
                        >
                          <b-radio
                            class="tw-mr-10 tw-capitalize"
                            v-model="recurring.repeatsBy"
                            v-for="(repeat, i) in recurring.repeats"
                            :key="`repeat-` + i"
                            :native-value="repeat"
                            >{{ repeat }}</b-radio
                          >
                        </b-field>
                      </validation-provider>
                    </div>
                    <div
                      class="tw-mb-5"
                      v-if="
                        recurring.repeatsBy === `weekly` &&
                          formEvent.values.is_recurring
                      "
                    >
                      <validation-provider
                        name="days_of_week"
                        rules="required:repeatby,weekly"
                        v-slot="{ errors }"
                      >
                        <b-field
                          class="tw-mb-2"
                          :message="errors"
                          :type="{ 'is-danger': errors.length }"
                          grouped
                          group-multiline
                        >
                          <b-checkbox
                            class="tw-mb-3 weekdays"
                            v-model="recurring.selectedWeekdays"
                            v-for="(weekday, i) in recurring.weekdays"
                            :key="`week-` + i"
                            :native-value="i"
                            >{{ weekday }}</b-checkbox
                          >
                        </b-field>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <div class="columns no-py">
                  <div
                    :class="[
                      'column is-6',
                      { 'is-12': !formEvent.values.is_recurring }
                    ]"
                  >
                    <b-field :label="date.start.label">
                      <b-datepicker
                        class="has-icons-override"
                        v-model="date.start.value"
                        :min-date="minDate"
                        :date-formatter="dateFormatter"
                        icon="calendar"
                      ></b-datepicker>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field
                      label="End Date"
                      v-if="formEvent.values.is_recurring"
                    >
                      <b-datepicker
                        class="has-icons-override"
                        v-model="date.end.value"
                        :min-date="date.start.value"
                        :date-formatter="dateFormatter"
                        icon="calendar"
                        position="is-bottom-left"
                      ></b-datepicker>
                    </b-field>
                  </div>
                </div>

                <div class="columns no-py" v-if="!formEvent.values.is_all_day">
                  <div class="column is-half">
                    <b-field :label="time.start.label">
                      <b-timepicker
                        class="has-icons-override"
                        icon="clock-outline"
                        v-model="time.start.value"
                        position="is-top-right"
                        :min-time="time.start.min"
                        :hour-format="timepicker.hourFormat"
                        :increment-minutes="timepicker.incrementMinutes"
                      ></b-timepicker>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field :label="time.end.label">
                      <b-timepicker
                        class="has-icons-override"
                        icon="clock-outline"
                        v-model="time.end.value"
                        position="is-top-right"
                        :min-time="time.end.min"
                        :hour-format="timepicker.hourFormat"
                        :increment-minutes="timepicker.incrementMinutes"
                      ></b-timepicker>
                    </b-field>
                  </div>
                </div>

                <b-field
                  grouped
                  class="tw-items-end columns"
                  v-if="!setCategory.isNew"
                >
                  <validation-provider
                    name="event_category_id"
                    rules="required"
                    v-slot="{ errors }"
                    class="column cat"
                  >
                    <b-field
                      label="Category"
                      :message="errors"
                      :type="{ 'is-danger': errors.length }"
                      expanded
                    >
                      <b-select
                        expanded
                        v-model="setCategory.selected"
                        :placeholder="setCategory.label"
                        :disabled="isLoading || setCategory.isListDisabled"
                        :loading="isLoading"
                        @input="setCategorySelected()"
                      >
                        <option
                          v-for="category in setCategory.list"
                          :value="category"
                          :key="`cat-` + category.id"
                          >{{ category.name }}</option
                        >
                      </b-select>
                    </b-field>
                  </validation-provider>

                  <b-field class="column tw-text-right is-one-quarter">
                    <v-swatches
                      :value="category.color"
                      shapes="circles"
                      :trigger-style="swatch.style"
                      class="tw-mx-auto"
                      disabled
                    ></v-swatches>
                  </b-field>
                </b-field>

                <p class="tw--mt-10 tw-z-5" v-if="!setCategory.isNew">
                  <small
                    ><a
                      class="tw-cursor-pointer"
                      @click.prevent="setCategory.isNew = true"
                      >Create a new category</a
                    ></small
                  >
                </p>

                <!-- SUB FORM, Create New Category -->
                <validation-observer v-slot="{ valid }" ref="createCat">
                  <b-field
                    grouped
                    class="cat tw-items-end columns"
                    v-if="setCategory.isNew"
                    expanded
                  >
                    <validation-provider
                      name="name"
                      rules="required"
                      v-slot="{ errors }"
                      class="column "
                    >
                      <b-field
                        label="Category Name"
                        :message="errors"
                        :type="{ 'is-danger': errors.length }"
                      >
                        <b-input v-model="category.name"></b-input>
                      </b-field>
                    </validation-provider>
                    <validation-provider
                      name="color"
                      rules="required"
                      v-slot="{ errors }"
                      class="column is-one-quarter"
                    >
                      <b-field
                        label="Set Color"
                        class="tw-text-right cat-swatch"
                        :message="errors"
                        :type="{ 'is-danger': errors.length }"
                        expanded
                      >
                        <v-swatches
                          class="tw-mx-auto"
                          v-model="category.color"
                          swatch-size="24"
                          shapes="circles"
                          popover-x="left"
                          popover-y="top"
                          :trigger-style="swatch.style"
                        ></v-swatches>
                      </b-field>
                    </validation-provider>
                  </b-field>

                  <div
                    class="tw--mt-6 tw-flex tw-items-end"
                    v-if="setCategory.isNew"
                  >
                    <small
                      ><a
                        class="tw-cursor-pointer"
                        @click.prevent="setCategory.isNew = false"
                        >Cancel</a
                      ></small
                    >
                    <b-button
                      class="tw-ml-5 tw-px-2 tw-py-1 tw-min-w-0"
                      size="is-small"
                      type="is-primary"
                      :loading="isLoading"
                      :disabled="isLoading || !valid"
                      @click.prevent="createCategory()"
                      >Done</b-button
                    >
                  </div>
                </validation-observer>
              </div>
            </div>
            <hr class="divider tw-mt-4" />
            <div class="level">
              <div class="level-left">
                <a @click="editCategories()">Edit Categories</a>
              </div>
              <div class="level-right">
                <small v-if="calendarAction === `edit-event`">
                  <a
                    :class="[
                      'tw-mr-10 has-text-danger',
                      { 'tw-cursor-not-allowed': isSubmitting }
                    ]"
                    @click.prevent="confirmDeleteEvent()"
                    >{{ labels.deleteBtn }}</a
                  ></small
                >
                <b-button
                  type="is-primary"
                  @click="submitEvent()"
                  :loading="isSubmitting"
                  :disabled="isSubmitting || !valid"
                  >{{ labels.submitBtn }}</b-button
                >
              </div>
            </div>
          </validation-observer>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import ModalMixin from '@/utils/mixins/modal'
import VSwatches from 'vue-swatches'
import dayjs from 'dayjs'

export default {
  name: 'AddCalendarEvent',
  mixins: [ModalMixin],
  props: {
    event: { type: Object }
  },
  components: {
    VSwatches
  },
  data() {
    return {
      opened: false,
      isLoading: false,
      isSubmitting: false,
      labels: {
        title: '',
        submitBtn: '',
        deleteBtn: 'Delete'
      },
      date: {
        start: {
          value: '',
          label: 'Date'
        },
        end: {
          value: '',
          label: 'End Date'
        }
      },
      time: {
        start: {
          min: undefined,
          value: '',
          label: 'Start Time'
        },
        end: {
          min: undefined,
          value: '',
          label: 'End Time'
        },
        addMinutes: 5
      },
      timepicker: {
        incrementMinutes: 5,
        hourFormat: '24'
      },
      category: {
        name: '',
        color: '',
        id: ''
      },
      setCategory: {
        selected: null,
        label: '',
        list: {},
        isNew: false,
        isListDisabled: true
      },
      swatch: {
        style: {
          width: '32px',
          height: '32px'
        }
      },
      recurring: {
        repeats: ['daily', 'weekly'],
        repeatsBy: '',
        weekdays: [],
        selectedWeekdays: [],
        placeholder: 'Select -'
      },
      formEvent: {
        defaults: {
          name: '',
          description: null,
          start_at: '',
          end_at: '',
          event_category_id: '',
          is_all_day: false,
          is_recurring: false
        },
        values: {}
      }
    }
  },
  watch: {
    date: {
      deep: true,
      handler(n) {
        if (dayjs(n.start.value) > dayjs(n.end.value)) {
          n.end.value = n.start.value
        }
        this.updateFormEventDate()
        this.updateMinTime()
      }
    },
    time: {
      deep: true,
      handler() {
        this.updateFormEventDate()
      }
    },
    'time.start.value'(n) {
      if (dayjs(n) >= dayjs(this.time.end.value)) {
        this.time.end.value = n
      }
      this.updateMinTime()
    },
    'formEvent.values.is_recurring'(n) {
      this.date.start.label = n ? 'Start Date' : 'Date'
      this.updateFormEventDate()

      if (n) {
        this.formEvent.values.repeat_by = this.recurring.repeatsBy
        this.formEvent.values.days_of_week = this.recurring.selectedWeekdays
      } else {
        delete this.formEvent.values.repeat_by
        delete this.formEvent.values.days_of_week
      }
    },
    'formEvent.values.is_all_day'() {
      this.updateFormEventDate()
    },
    'setCategory.isNew'(n) {
      this.category = {
        name: '',
        color: ''
      }
      if (!n) {
        this.setCategory.selected = null
      }
    },
    'category.id'(n) {
      this.formEvent.values.event_category_id = n
    },
    'recurring.selectedWeekdays'(n) {
      this.formEvent.values.days_of_week = n
    },
    'recurring.repeatsBy'(n) {
      this.formEvent.values.repeat_by = n
      this.formEvent.values.days_of_week = []

      if (n === 'daily') {
        this.recurring.weekdays.forEach((day, key) => {
          this.formEvent.values.days_of_week.push(key)
        })
      } else {
        this.formEvent.values.days_of_week = this.recurring.selectedWeekdays
      }
    }
  },
  computed: {
    ...mapState({
      group: state => state.group.currentGroup,
      groupEventDetail: state => state.group.calendar.eventDetails,
      calendarCategories: state => state.group.calendar.categories,
      masterEventDetail: state => state.calendar.eventDetails,
      calendarOptions: state => state.calendar.options,
      calendarAction: state => state.calendar.action
    }),

    minDate() {
      return dayjs().$d
    },
    dateFormatter() {
      return date =>
        dayjs(date).format('DD/MM/YYYY', {
          timeZone: this.calendarOptions.timeZone
        })
    }
  },
  methods: {
    ...mapActions({
      getCalendarCategories: 'group/getCalendarCategories',
      postCalendarCategories: 'group/postCalendarCategories',
      postCalendarEvent: 'group/postCalendarEvent',
      updateCalendarEvent: 'group/updateCalendarEvent'
    }),
    ...mapMutations(['setCalendarAction']),

    async open() {
      this.opened = true
      if (this.calendarAction === 'create-event') this.clearFields()
      this.setFormAction()
      if (this.calendarAction === 'create-event') await this.setTimeInit()
      this.updateMinTime()
      this.setWeekdays()
      await this.getCategories()
      await this.$emit('opened')
    },
    clearCategory() {
      this.category = {
        name: '',
        color: ''
      }
    },
    clearFields() {
      this.setCategory.selected = null
      this.setCategory.isNew = false
      this.formEvent.values = Object.assign({}, this.formEvent.defaults)
      this.date.start.value = this.date.end.value = this.minDate
      this.recurring.selectedWeekdays = []
      if (this.event.date) this.date.start.value = new Date(this.event.date)
      this.clearCategory()
    },
    setFormAction() {
      if (this.calendarAction === 'create-event') {
        this.labels.title = 'Create New Event'
        this.labels.submitBtn = 'Add Event'
      } else if (this.calendarAction === 'edit-event') {
        this.labels.title = 'Edit Event'
        this.labels.submitBtn = 'Save Changes'
        this.populateFields()
      }
    },
    setCategorySelected() {
      this.category = this.setCategory.selected
    },
    setWeekdays() {
      this.recurring.weekdays = dayjs.weekdaysShort()
    },
    setTimeInit() {
      let currMins = dayjs().minute()
      let setHours = dayjs()
      let setCurrMins = null

      switch (true) {
        case currMins >= 0 && currMins <= 5:
          setCurrMins = '5'
          break
        case currMins >= 6 && currMins <= 10:
          setCurrMins = '10'
          break
        case currMins >= 11 && currMins <= 15:
          setCurrMins = '15'
          break
        case currMins >= 16 && currMins <= 20:
          setCurrMins = '20'
          break
        case currMins >= 21 && currMins <= 25:
          setCurrMins = '25'
          break
        case currMins >= 26 && currMins <= 30:
          setCurrMins = '30'
          break
        case currMins >= 31 && currMins <= 35:
          setCurrMins = '35'
          break
        case currMins >= 36 && currMins <= 40:
          setCurrMins = '40'
          break
        case currMins >= 41 && currMins <= 45:
          setCurrMins = '45'
          break
        case currMins >= 46 && currMins <= 50:
          setCurrMins = '50'
          break
        case currMins >= 51 && currMins <= 55:
          setCurrMins = '55'
          break
        case currMins >= 56 && currMins <= 59:
          setCurrMins = '00'
          setHours = setHours.add(1, 'h')
          break
      }

      let currTime = setHours.minute(parseInt(setCurrMins)).valueOf()
      this.time.start.value = new Date(currTime)
      this.time.end.value = new Date(
        dayjs(currTime).add(this.time.addMinutes, 'm')
      )
    },
    updateMinTime() {
      let selectedDate = dayjs(this.date.start.value)
        .startOf('d')
        .valueOf()
      let todaysDate = dayjs()
        .startOf('d')
        .valueOf()

      if (selectedDate === todaysDate) {
        this.time.start.min = new Date()
      } else {
        this.time.start.min = undefined
      }
      let minStartTime = dayjs(this.time.start.value).add(
        this.time.addMinutes,
        'm'
      )
      this.time.end.value = this.time.end.min = new Date(minStartTime)
    },
    updateFormEventDate() {
      let timeStart = dayjs(this.time.start.value)
      let dateStart = dayjs(this.date.start.value)
        .tz(this.calendarOptions.timeZone)
        .format()
      let timeEnd = dayjs(this.time.end.value)
      let dateEnd = dayjs(this.date.end.value)
        .tz(this.calendarOptions.timeZone)
        .format()

      if (!this.formEvent.values.is_all_day) {
        // set the time
        dateStart = dayjs(dateStart)
          .hour(timeStart.$H)
          .minute(timeStart.$m)
          .valueOf()

        dateEnd = dayjs(dateEnd)
          .hour(timeEnd.$H)
          .minute(timeEnd.$m)
          .valueOf()
      } else if (this.formEvent.values.is_all_day) {
        dateStart = dayjs(dateStart).startOf('d')
        dateEnd = dayjs(dateEnd).startOf('d')
      }

      if (
        !this.formEvent.values.is_recurring &&
        !this.formEvent.values.is_all_day
      ) {
        // same day, different time
        dateEnd = dayjs(dateStart)
          .hour(timeEnd.$H)
          .minute(timeEnd.$m)
          .valueOf()
      }

      this.formEvent.values.start_at = dayjs(dateStart)
        .utc()
        .format()
      this.formEvent.values.end_at = dayjs(dateEnd)
        .utc()
        .format()
    },
    getCategories() {
      this.isLoading = true

      this.getCalendarCategories()
        .then(() => {
          this.setCategory.isListDisabled = false
          this.setCategory.list = this.calendarCategories

          this.setCategory.label =
            this.calendarCategories.length > 0 ? 'Select -' : 'No category yet'
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async createCategory() {
      const newCategory = Object.assign({}, this.category)
      delete newCategory.id
      await this.postCategories(newCategory)
    },
    postCategories(category) {
      this.isLoading = true

      this.postCalendarCategories(category)
        .then(() => {
          this.getCategories()
          return this.setCategory.isNew ? (this.setCategory.isNew = false) : ''
        })
        .catch(error => {
          this.$refs.createCat.setErrors(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    editCategories() {
      this.opened = false
      this.$emit('editCategories')
    },
    postEvent() {
      this.isSubmitting = true
      this.formEvent.values.days_of_week.sort((a, b) => a - b)

      this.postCalendarEvent(this.formEvent.values)
        .then(async () => {
          this.opened = false
          await this.$refs.createEv.reset()
          await this.clearFields()
          this.$emit('closed')
        })
        .catch(error => {
          this.$refs.createEv.setErrors(error)
        })
        .finally(async () => {
          this.isSubmitting = false
        })
    },
    updateEvent() {
      this.isSubmitting = true

      this.updateCalendarEvent(this.formEvent.values)
        .then(async () => {
          this.opened = false
          await this.$refs.createEv.reset()
          await this.clearFields()
          this.$emit('closed')
        })
        .catch(error => {
          this.$refs.createEv.setErrors(error)
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
    confirmDeleteEvent() {
      this.opened = false
      this.$emit('confirmDeleteEvent')
    },
    submitEvent() {
      if (this.calendarAction === 'create-event') {
        this.postEvent()
      } else if (this.calendarAction === 'edit-event') {
        this.updateEvent()
      }
    },
    populateFields() {
      this.getCategories()
      if (this.event.type === 'group') {
        this.formEvent.values.is_all_day = !!this.groupEventDetail.allDay
        this.formEvent.values.is_recurring = !!this.groupEventDetail.startRecur

        this.formEvent.values.id = this.groupEventDetail.id
        this.formEvent.values.name = this.groupEventDetail.title
        this.formEvent.values.description = this.groupEventDetail.extendedProps.description

        this.setCategory.selected = this.category
        this.category.color = this.groupEventDetail.color
        this.category.name = this.groupEventDetail.extendedProps.category
        this.category.id = this.formEvent.values.event_category_id = this.groupEventDetail.extendedProps.event_category_id

        this.recurring.repeatsBy = this.formEvent.values.repeat_by = this.groupEventDetail.extendedProps.repeat_by
        this.recurring.selectedWeekdays = this.formEvent.values.days_of_week = this.groupEventDetail.daysOfWeek

        this.date.start.value = this.time.start.value = new Date(
          this.groupEventDetail.start
        )
        this.date.end.value = this.time.end.value = new Date(
          this.groupEventDetail.end
        )
      }
      if (this.groupEventDetail.allDay && !this.groupEventDetail.startRecur) {
        this.date.end.value = this.time.end.value = new Date(
          this.groupEventDetail.start
        )
      }
      if (this.formEvent.values.is_recurring) {
        this.date.start.value = this.time.start.value = new Date(
          this.groupEventDetail.startRecur
        )
        this.date.end.value = this.time.end.value = new Date(
          this.groupEventDetail.endRecur
        )
      }
      this.updateFormEventDate()
    },
    refreshState() {
      this.setCalendarAction('')
      this.clearFields()
    }
  }
}
</script>

<style lang="sass">
.card-content
  overflow-x: hidden !important

.event-add
  .control
    &.has-icons-override
        .icon
          margin-left: 5px
          color: #747474
    .input
      margin-top: -3px

  .select.is-loading:after
    margin-top: 5px
  .is-vcentered *
    vertical-align: top
  .weekdays
    width: 70px
  .repeat-by label:first-child
    width: 100%

.vue-swatches
  margin: 0
  padding: 0

.vue-swatches__trigger.vue-swatches--is-empty
  margin-bottom: 8px

.field > .help.is-danger
  line-height: 1.3em

.cat
  position: relative

  .field > .help.is-danger
    position: absolute
    bottom: 12px
  .cat-swatch > .help.is-danger
    right: 0

.columns
  &.no-py .column
    padding-top: 0
    padding-bottom: 0
</style>
